const BrandQueryKey = {
  RECOMMEND_BRAND: 'RECOMMEND_BRAND',
  SEARCH_BRAND: 'SEARCH_BRAND',
  SEARCH_BRAND_PRODUCTS: 'SEARCH_BRAND_PRODUCTS',
};

export default BrandQueryKey;
